import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';

export const SSOCallback = () => {
  // Handle the redirect flow by calling the Clerk.handleRedirectCallback() method
  // or rendering the prebuilt <AuthenticateWithRedirectCallback/> component.
  // This is the final step in the custom OAuth flow.
  const activeOrgId = window.localStorage.getItem('active-org-id');
  if (!activeOrgId) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="size-4 animate-spin" />
        <AuthenticateWithRedirectCallback />
      </div>
    );
  }

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Loader2 className="size-4 animate-spin" />
      <AuthenticateWithRedirectCallback
        signInFallbackRedirectUrl={`${window.location.origin}/${activeOrgId}/auth/join-org`}
        signUpFallbackRedirectUrl={`${window.location.origin}/${activeOrgId}/auth/join-org`}
      />
    </div>
  );
};
